import { queryClient } from '@/fetching/queryClient';
import {
    PERSISTENT_LOCAL_STORAGE_KEYS,
    PERSISTENT_SESSION_STORAGE_KEYS,
} from '@/utils/browserStorage';
import { useCallback } from 'react';

const readPersistentData = (storage: Storage, keys: Set<string>) => {
    const persistentData = new Map<string, string>();
    keys.forEach((key) => {
        const value = storage.getItem(key);
        if (value !== null) {
            persistentData.set(key, value);
        }
    });
    return persistentData;
};

const restorePersistentData = (storage: Storage, persistentData: Map<string, string>) => {
    persistentData.forEach((value, key) => {
        storage.setItem(key, value);
    });
};

export const clearLocalData = () => {
    const persistentLocalData = readPersistentData(localStorage, PERSISTENT_LOCAL_STORAGE_KEYS);
    const persistentSessionData = readPersistentData(
        sessionStorage,
        PERSISTENT_SESSION_STORAGE_KEYS,
    );

    localStorage.clear();
    sessionStorage.clear();

    // Wipe the React Query cache so no cached PHI/PII survives logout. Any "zombie"
    //  query this may leave behind (see clearAuthState.ts) is harmless: the cache is
    //  cleared again on the next sign-in (useEnterAuthenticatedSession) before any
    //  authenticated page mounts.
    queryClient.clear();

    restorePersistentData(localStorage, persistentLocalData);
    restorePersistentData(sessionStorage, persistentSessionData);
};

export const useClearLocalData = () => {
    return useCallback(clearLocalData, []);
};

export const softResetLocalData = (route: string, uuid?: string) => {
    return queryClient.invalidateQueries(uuid ? [route, uuid] : [route]);
};
